import { createStore } from 'vuex'
import actions from './actions'
import mutations from './mutations'
import client from './modules/client'
import auth from './modules/auth'
import user from './modules/user'

export default createStore({
  actions,
  mutations,
  modules: {
    client,
    auth,
    user
  }
})
